import { TanStackDevtools } from '@tanstack/react-devtools'
import type { QueryClient } from '@tanstack/react-query'
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
} from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import Footer from '@/components/layout/footer/footer'
import Header from '@/components/layout/header'
import NotFound404 from '@/components/layout/notFound404'
import TanStackQueryDevtools from '../integrations/tanstack-query/devtools'

interface MyRouterContext {
	queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: Layout,
	notFoundComponent: NotFound404,
	// head: () => ({
	// 	scripts: import.meta.env.DEV
	// 		? [
	// 				{
	// 					children: 'console.log("static script loaded")',
	// 				},
	// 				{
	// 					type: 'text/javascript',
	// 					src: 'https://cdn.cookielaw.org/consent/1aa327c4-a872-41f5-8339-9af002119223/OtAutoBlock.js',
	// 					defer: false,
	// 				},
	// 				{
	// 					type: 'text/javascript',
	// 					src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
	// 					charSet: 'UTF-8',
	// 					'data-domain-script':
	// 						'1aa327c4-a872-41f5-8339-9af002119223',
	// 				},
	// 				{
	// 					type: 'text/javascript',
	// 					id: 'oneTrust',

	// 					children: `function OptanonWrapper() { const event = new Event('OneTrustEvent'); document.body.dispatchEvent(event); };`,
	// 					defer: false,
	// 				},
	// 				{
	// 					children: 'console.log("hello world")',
	// 				},
	// 			]
	// 		: [],
	// }),
})

function Layout() {
	return (
		<>
			<HeadContent />
			<Header />
			<Outlet />
			<Footer />
			<TanStackDevtools
				config={{
					position: 'bottom-right',
				}}
				plugins={[
					{
						name: 'Tanstack Router',
						render: <TanStackRouterDevtoolsPanel />,
					},
					TanStackQueryDevtools,
				]}
			/>
		</>
	)
}
